const BASE_SELECTOR: string = '.gamecloud__header';
export const ACTIVATE_GAMECLOUD_HEADER_BUTTON_SELECTOR: string = '[data-gamecloud-activate]';
export const REACTIVATE_GAMECLOUD_HEADER_BUTTON_SELECTOR: string = '[data-gamecloud-reactivate]';

export class GamecloudheaderUI {

  public orderid: number = this.$base.data('orderid');

  public constructor(private $base: JQuery) {}

  public onActivateButtonClick(callback: (button) => void) {
    this.$base.find(ACTIVATE_GAMECLOUD_HEADER_BUTTON_SELECTOR).off('click');
    this.$base.find(ACTIVATE_GAMECLOUD_HEADER_BUTTON_SELECTOR).on('click', (el) => {
      callback(this.$base.find(ACTIVATE_GAMECLOUD_HEADER_BUTTON_SELECTOR));
    });
  }

  public onReactivateButtonClick(callback: (button) => void) {
    this.$base.find(REACTIVATE_GAMECLOUD_HEADER_BUTTON_SELECTOR).off('click');
    this.$base.find(REACTIVATE_GAMECLOUD_HEADER_BUTTON_SELECTOR).on('click', (el) => {
      callback(this.$base.find(REACTIVATE_GAMECLOUD_HEADER_BUTTON_SELECTOR));
    });
  }

  public setButtonLoading(state: boolean, button) {
    if (state) {
      $(button).addClass('loading');
    } else {
      $(button).removeClass('loading');
    }
  }
}

export function createGamecloudheaderInstances(): GamecloudheaderUI[] {
  const instances: GamecloudheaderUI[] = [];
  $(BASE_SELECTOR).each((index, el) => {
    instances.push(new GamecloudheaderUI($(el)));
  });

  return instances;
}
